<template>
  <div>
    <div v-for="(str, index) in splitStr(item.clients.name)" :key="index">{{
      str
    }}</div>
  </div>
</template>

<script>
export default {
  name: "order-status-warehouse-name",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
